// components/FormularSesizare/CompletionScreen.jsx

import React from "react";
import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import { toast } from 'react-toastify';

// Soft UI Components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { primaryBtnSx, navyBtnSx } from "./colors";

function CompletionScreen({ codSesizare, email, handleReset, customColors }) {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(codSesizare);
    toast.success("Codul a fost copiat cu succes!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  return (
    <SoftBox p={3} textAlign="center">
      <SoftBox mb={3} display="flex" justifyContent="center">
        <Icon fontSize="large" sx={{ fontSize: "4rem", color: customColors.success.main }}>
          check_circle
        </Icon>
      </SoftBox>

      <SoftTypography variant="h4" fontWeight="bold" mb={1} sx={{ color: customColors.secondary.main }}>
        Sesizarea dumneavoastră a fost trimisă cu succes!
      </SoftTypography>

      <SoftTypography variant="body1" mb={4} sx={{ color: customColors.secondary.light }}>
        Am trimis un email de confirmare la adresa <strong>{email}</strong>.
      </SoftTypography>

      <SoftBox
        mb={4}
        p={4}
        border="1px solid"
        borderColor="rgba(6, 29, 54, 0.12)"
        borderRadius="lg"
        bgcolor={customColors.secondary.focus}
      >
        <SoftTypography variant="h6" fontWeight="bold" mb={1} sx={{ color: customColors.secondary.main }}>
          Codul unic al sesizării dumneavoastră:
        </SoftTypography>

        <SoftTypography variant="h4" fontWeight="bold" sx={{ letterSpacing: "2px", color: customColors.primary.main }}>
          {codSesizare}
        </SoftTypography>

        <SoftButton
          variant="contained"
          size="small"
          onClick={copyToClipboard}
          sx={{ mt: 2, ...navyBtnSx }}
        >
          <Icon>content_copy</Icon>&nbsp;
          Copiază codul
        </SoftButton>
      </SoftBox>

      <SoftTypography variant="body2" sx={{ color: customColors.secondary.light, mb: 4 }}>
        Vă rugăm să păstrați acest cod pentru a putea urmări statusul sesizării dumneavoastră.
      </SoftTypography>

      <SoftButton variant="contained" onClick={handleReset} sx={primaryBtnSx}>
        Trimite o nouă sesizare
      </SoftButton>
    </SoftBox>
  );
}

CompletionScreen.propTypes = {
  codSesizare: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  handleReset: PropTypes.func.isRequired,
  customColors: PropTypes.shape({
    primary: PropTypes.shape({ main: PropTypes.string }).isRequired,
    secondary: PropTypes.shape({
      main: PropTypes.string,
      focus: PropTypes.string,
      dark: PropTypes.string,
    }).isRequired,
    success: PropTypes.shape({ main: PropTypes.string }).isRequired,
  }).isRequired,
};

export default CompletionScreen;
